import component from './promocode-redirect.component';

export default angular
  .module('fizyweb.paycell.promocode.redirect', [])
  .component('fizyPaycellPromocodeRedirect', component).name;



// WEBPACK FOOTER //
// src/app/components/promocode-redirect/promocode-redirect.module.ts